export default "__VITE_ASSET__BPep8STa__"